import { ITextBox, ToolType } from "../../types/Floorplan.types";

export interface IDesksProps {
    textBoxes?: ITextBox[];
    selectedTextIdx?: number;
    selectedObjects?: Record<string, number[]>;
    selectedTool?: ToolType;
}

const TextElements = (props: IDesksProps) => {
    const { textBoxes, selectedTextIdx, selectedTool } = props;
    if (textBoxes && textBoxes.length > 0) {
        return (
            <g id="text">
                { textBoxes.map((textBox, idx) => {
                    let cursor: string | undefined = undefined;
                    let className = "text text-" + idx;
                    if ((selectedTool === "Pointer" || selectedTool === "Text") && (selectedTextIdx === idx || (props.selectedObjects && props.selectedObjects.textBoxes.includes(idx)))) {
                        className = "draggable text draggableText-" + idx;
                    }

                    let textStr = textBox.text;
                    if (!textStr || textStr.trim() === "") {
                        textStr = "Text";
                    }
                    let textArr = textStr.split('\n');
                    
                    return (
                        <svg key={`text-${idx}`} data-idx={idx} className={className} pointerEvents="all" style={{cursor, userSelect: "none"}} x={textBox.x} y={textBox.y} overflow="visible">
                            <text enableBackground="true" dominantBaseline="middle" textAnchor="middle" fontSize={textBox.fontSize === "large" ? undefined : "8"}>
                                { textArr.length > 1 && textArr.map((textComponent, idx) => (
                                    <tspan x="0" dy={idx > 0 ? "15" : undefined}>{textComponent}</tspan>
                                )) }
                                { textArr.length === 1 && textStr }
                            </text>
                        </svg>
                    );
                }) }
            </g>
        );
    }
    return null;
};

export default TextElements;